function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import classnames from 'classnames';
import { paramCase } from 'change-case';
import FilePickerSource from './sources/file-picker-source';
import MyDeviceSource from './sources/my-device-source';
import UrlSource from './sources/url-source';
import { CloseOutlined } from '@ant-design/icons';

function isSourceWrapperSignature(type) {
  var isGenericSource = /^FilePickerSource$/i.test(type);
  return /Source$/i.test(type) && !isGenericSource;
}

var VALID_CHILDREN = [FilePickerSource.name, MyDeviceSource.name, UrlSource.name];

function normalizeSourceWrapperType(type) {
  if (isSourceWrapperSignature(type)) {
    type = paramCase(type.replace(/Source$/i, ''));
  }

  return type;
}

function getChildType(child) {
  var _ref, _type;

  var type = child.props.type;
  var childTypeName = (_ref = (_type = child.type.type) !== null && _type !== void 0 ? _type : child.type.displayName) !== null && _ref !== void 0 ? _ref : child.type.name;

  if (isSourceWrapperSignature(childTypeName)) {
    type = normalizeSourceWrapperType(childTypeName);
  } else if (!type && childTypeName) {
    type = childTypeName;
  }

  return type;
}

function getSourceComponent(source) {
  var sourceComponent;

  switch (source.type) {
    case MyDeviceSource.type:
      sourceComponent = MyDeviceSource;
      break;

    case UrlSource.type:
      sourceComponent = UrlSource;
      break;

    default:
      console.debug('[FilePicker] invalid FilePickerSource detected', source.type, source);
      throw new Error('Invalid FilePickerSource detected');
  }

  return sourceComponent;
}

function extractSources(sources) {
  return React.Children.map(sources, function (child) {
    var props = _extends({}, child.props);

    var type = getChildType(child);
    var component = getSourceComponent({
      type: type
    });
    return {
      type: type,
      props: props,
      source: child,
      component: component
    };
  });
}

function ensureChildTypes(children) {
  var currentChildTypes = [];
  React.Children.forEach(children, function (child) {
    if (React.isValidElement(child)) {
      if (typeof child.type !== 'function' || !VALID_CHILDREN.includes(child.type.name)) {
        throw new Error('FilePicker children must be FilePicker Modules.');
      }

      var type = getChildType(child);

      if (currentChildTypes.includes(type)) {
        throw new Error("Only one [".concat(type, "] FilePicker Module can be provided."));
      }

      currentChildTypes.push(type);
    }
  });
}

var FilePicker = function FilePicker(props) {
  var _activeSource$props$i;

  var className = props.className,
      onSourceChange = props.onSourceChange,
      children = props.children;
  React.useEffect(function () {
    ensureChildTypes(children);
  }, []);
  var sources = extractSources(children);

  var _React$useState = React.useState(sources[0].type),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      activeSourceType = _React$useState2[0],
      setActiveSourceType = _React$useState2[1];

  var activeSource = sources.find(function (m) {
    return m.type === activeSourceType;
  });
  var activeContent = React.cloneElement(activeSource.source, {
    active: true
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classnames('sw-file-picker', className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "close-button",
    onClick: props.handleClose
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(CloseOutlined, null))), /*#__PURE__*/React.createElement("div", {
    className: classnames('swfp-picker')
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames('swfp-content')
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames('swfp-nav')
  }, sources.map(function (src) {
    var _src$props$icon, _src$props$label;

    return /*#__PURE__*/React.createElement("div", {
      key: src.type,
      className: classnames('swfp-nav-item', {
        'swfp-nav-item-active': src.type === activeSource.type
      }),
      onClick: function onClick() {
        setActiveSourceType(src.type);
        onSourceChange === null || onSourceChange === void 0 ? void 0 : onSourceChange(src.type);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: classnames('swfp-nav-item-icon')
    }, (_src$props$icon = src.props.icon) !== null && _src$props$icon !== void 0 ? _src$props$icon : src.component.defaultIcon), /*#__PURE__*/React.createElement("span", {
      className: classnames('swfp-nav-item-label')
    }, (_src$props$label = src.props.label) !== null && _src$props$label !== void 0 ? _src$props$label : src.component.defaultLabel));
  })), /*#__PURE__*/React.createElement("div", {
    className: classnames('swfp-body-wrapper')
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames('swfp-header')
  }, /*#__PURE__*/React.createElement("span", {
    className: classnames('swfp-header-icon')
  }, (_activeSource$props$i = activeSource.props.icon) !== null && _activeSource$props$i !== void 0 ? _activeSource$props$i : activeSource.component.defaultIcon)), /*#__PURE__*/React.createElement("div", {
    className: classnames('swfp-body')
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames('swfp-module', "".concat(activeSource.type, "-module"))
  }, activeContent))))));
};

FilePicker.Source = FilePickerSource;
FilePicker.MyDevice = MyDeviceSource;
FilePicker.Url = UrlSource;
export default FilePicker;